import { useRouter } from 'next/router'
import React from 'react'
import { Navbar, Footer, Head } from '../webpage'

export function Layout({ children }) {
    const { locale } = useRouter()
    return (
        <div
            css={(theme) => {
                return {
                    color: theme.colors.text,
                    fontFamily: theme.font[locale]?.main ?? theme.font['default']?.main,
                    backgroundColor: theme.colors.mainBackground,
                    direction: ['ar', 'fa'].indexOf(locale) !== -1 ? 'rtl' : 'ltr',
                    position: 'relative'
                }
            }}
        >
            {/* {console.log('theme font', theme.font)}
            {console.log(theme.locale)} */}
            <Head />
            <Navbar />
            <div>{children}</div>
            <Footer />
        </div>
    )
}
